import { useContext } from 'react'
import { AmplitudeContext } from '@/src/contexts'

import { Button } from 'antd'
import { trackPhysicianEvents } from '@/src/lib'

import { Physician } from '@/src/interfaces'

interface RequestAppointmentButtonProps {
  physician: Physician
  position: number
  onRequestAppointment: (physician: Physician) => void
  buttonText?: string
}

export const RequestAppointmentButton = ({
  physician,
  position,
  onRequestAppointment,
  buttonText = 'Request Appointment',
}: RequestAppointmentButtonProps) => {
  const { trackAmplitudeEvent } = useContext(AmplitudeContext)

  // Only render if physician has booking URL or telehealth appointments
  if (!physician.booking_url && physician.telehealth_appointment !== 'true') {
    return null
  }

  const handleClick = () => {
    // Amplitude - Track the request appointment event
    trackPhysicianEvents.requestAppointment(trackAmplitudeEvent)({
      ...physician,
      position: position,
    })
    onRequestAppointment(physician)
  }

  return (
    <Button className='w-48' type='primary' onClick={handleClick}>
      {buttonText}
    </Button>
  )
}
